import { useEffect, useRef } from "react";
import "./index.css";

export default function ChatBot() {
  const iframeWrapperRef = useRef(null);

  const handleEvent = (event) => {
    const iframeWrapper = iframeWrapperRef.current;

    if (iframeWrapper) {
      if (event.data.isChatboxOpen === true) {
        iframeWrapper.style.height = "100vh";

        if (window.innerWidth < 1024) {
          iframeWrapper.style.width = "100vw";
        } else {
          iframeWrapper.style.width = "484px";
        }
      } else if (event.data.isChatboxOpen === false) {
        setTimeout(()=>{
          iframeWrapper.style.height = "60px";
          iframeWrapper.style.width = "60px";
        }, 200)
      }
    }
  };

  // Attach the event listener when the component mounts
  useEffect(() => {
    window.addEventListener("message", handleEvent, false);

    // Cleanup the event listener when the component unmounts
    return () => {
      window.removeEventListener("message", handleEvent);
    };
  }, []); // Empty dependency array ensures the effect runs once after the initial render

  return (
    <iframe
      ref={iframeWrapperRef}
      src="https://mychat.danabot.ir/?chId=8f8f7aad-2268-47a0-b50e-52775fc9c131&title=chatbot"
      title="chatbot"
       allow="microphone"
      className="chatBotIframe"
    />
  );
}
